/**
 * PortalSelector - Popup to choose between multiple portals
 * Shows when user has access to multiple portals
 */

import React from 'react';
import './PortalSelector.css';

export interface Portal {
  id: string;
  name: string;
  icon: string;
  url: string;
}

interface Props {
  portals: Portal[];
  userName?: string;
  onSelect: (portal: Portal) => void;
  onClose?: () => void;
}

const PortalSelector: React.FC<Props> = ({ portals, userName, onSelect, onClose }) => {
  if (portals.length <= 1) return null;

  return (
    <div className="portal-selector-overlay">
      <div className="portal-selector-modal">
        <h2>Welcome back{userName ? `, ${userName}` : ''}!</h2>
        <p>Where would you like to go?</p>

        <div className="portal-options">
          {portals.map(portal => (
            <button
              key={portal.id}
              className="portal-option"
              onClick={() => onSelect(portal)}
            >
              <span className="portal-icon">{portal.icon}</span>
              <span className="portal-name">{portal.name}</span>
            </button>
          ))}
        </div>

        {onClose && (
          <button className="portal-close-btn" onClick={onClose}>
            Cancel
          </button>
        )}
      </div>
    </div>
  );
};

export default PortalSelector;
